<template>
    <div></div>
</template>

<script>
  export default {
    name: 'EmailChangePage',
    mounted () {
      this.changeRequest()
    },
    data () {
      return {
        token: this.$route.params.token
      }
    },
    methods: {
      changeRequest () {
        this.$api.post('/v1/auth/email-change/' + this.token).then(() => {
          this.$events.fire('message-open', {
            type: 'success',
            message: this.$t('message.emailChanged')
          })
          this.$router.push('/login')
        }).catch(() => {
          this.$events.fire('message-open', {
            type: 'error',
            message: this.$t('message.somethingWentWrong')
          })
          this.$router.push('/login')
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Homepage/ConfirmChangeEmail.vue